import api from './api';
import type { IApiResponse } from '@/types';

export type NotificationPriority = 'HIGH' | 'MEDIUM' | 'LOW';

export interface INotification {
  id: string;
  companyId: string;
  userId?: string | null;
  eventType: string;
  priority: NotificationPriority;
  channels: string[];
  title: string;
  message: string;
  metadata?: Record<string, unknown>;
  readAt?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface INotificationFilters {
  page?: number;
  limit?: number;
  priority?: NotificationPriority;
  eventType?: string;
  unreadOnly?: boolean;
  scope?: 'me' | 'all';
}

export const notificationsService = {
  async list(filters: INotificationFilters = {}): Promise<IApiResponse<INotification[]>> {
    const params: Record<string, string | number> = {};
    if (filters.page) params.page = filters.page;
    if (filters.limit) params.limit = filters.limit;
    if (filters.priority) params.priority = filters.priority;
    if (filters.eventType) params.eventType = filters.eventType;
    if (filters.unreadOnly) params.unreadOnly = 'true';
    if (filters.scope) params.scope = filters.scope;
    const { data } = await api.get<IApiResponse<INotification[]>>('/notifications', { params });
    return data;
  },

  async unreadCount(): Promise<{ count: number }> {
    const { data } = await api.get<IApiResponse<{ count: number }>>('/notifications/unread-count');
    return data.data ?? { count: 0 };
  },

  async markAsRead(id: string): Promise<void> {
    await api.patch(`/notifications/${id}/read`);
  },

  async markAllAsRead(): Promise<{ updated: number }> {
    const { data } = await api.patch<IApiResponse<{ updated: number }>>('/notifications/read-all');
    return data.data ?? { updated: 0 };
  },

  async scan(): Promise<Record<string, number>> {
    const { data } = await api.post<IApiResponse<Record<string, number>>>('/notifications/scan');
    return data.data ?? {};
  },
};
